// Types
import { InvestigationActionPayload } from 'app/modules/investigations/types/requests';
import {
  InvestigationsActionResponse,
  InvestigationsPayload,
} from 'app/modules/investigations/types';

// Utils
import { get, post } from 'app/shared/utils/fetchr';
import { consoleError } from 'app/shared/utils/console';

export const retrieveInvestigationsCase = <TResponse>(
  payload: InvestigationsPayload,
  useCached = false,
) => {
  if (useCached) {
    if (!payload?.object_ids?.[0]) {
      consoleError({
        error: 'No object_ids provided',
        info: { payload },
      });
      return Promise.reject(new Error('No object_ids provided'));
    }
    return get<TResponse>(`/v1/cases/cached/${payload?.object_ids?.[0]}`);
  }
  return post<TResponse>('/v1/investigations/retrieve/case', payload);
};

export const retrieveInvestigationAgentStats = (
  payload: InvestigationsPayload,
) => post('/v1/investigations/agent-stats', payload);

export const performInvestigationAction = (
  payload: InvestigationActionPayload,
  useCached = false,
) => {
  const url = useCached
    ? '/v1/investigations/cached/action'
    : '/v1/investigations/action';
  return post<InvestigationsActionResponse>(url, payload);
};
